import actions from './actions'
import { initialDataState, reduceDataError, reduceDataRequest, reduceDataSuccess } from '../../../reducersHelper'

const initState = {
  serviceUserAlerts: initialDataState
}

const reducers = (state = initState, action) => {
  switch (action.type) {
    case actions.CLEAR_SERVICEUSER_ALERTS:
      return initState

    case actions.GET_SERVICEUSER_ALERTS_REQUEST:
      return reduceDataRequest(state, 'serviceUserAlerts')
    case actions.GET_SERVICEUSER_ALERTS_SUCCESS:
      return reduceDataSuccess(state, 'serviceUserAlerts', action.payload)
    case actions.GET_SERVICEUSER_ALERTS_ERROR:
      return reduceDataError(state, 'serviceUserAlerts', action.error)

    default:
      return state
  }
}

export default reducers
